import React from 'react'
// components
import { ReduxSelect } from 'components/FormElements'
// types
import { IOption } from 'components/FormElements/Select'
import { ReduxSelectProps } from 'components/FormElements/ReduxForm/ReduxSelect'

interface Props extends ReduxSelectProps {
  name: string
  options: IOption[]
}

// A select that keeps the plain value in the form, not the option: the chart config is plain JSON
const PlainSelect: React.FC<Props> = ({ options, ...props }) => {
  const fieldProps = {
    format: (value: unknown) => options.find((option) => option.value === value) || null,
    parse: (option: IOption | null) => option?.value ?? null
  }

  return (
    <ReduxSelect
      {...props}
      {...fieldProps}
      options={options}
      // Over the drawer, by the window: opening the menu scrolls nothing, the page behind the drawer included
      menuPosition='fixed'
      menuShouldScrollIntoView={false}
    />
  )
}

export default PlainSelect
